import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: 'Seed your local database',
    description:
      'Populate your local database with realistic data for development and testing purposes.',
  },
  {
    icon: <ConstructionRoundedIcon />,
    title: 'Augment your Machine Learning datasets',
    description:
      'Elevate your machine learning with Cynthia! Our advanced SaaS platform boosts dataset quality, driving unparalleled performance and insights.',
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: 'Customizable Data Types',
    description:
      'Generate data that fits your needs. Cynthia supports a wide range of data types, including names, addresses, emails, and more.',
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title: 'Easy Integration',
    description:
      'Seamlessly integrate Cynthia into your existing workflows with our easy-to-use API, CLI, and SDKs.',
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: 'Robust Scalability',
    description:
      'Cynthia is built to scale with your business. Generate as much data as you need, when you need it.',
  },
  {
    icon: <QueryStatsRoundedIcon />,
    title: 'Precision in every detail',
    description:
      'Cynthia generates data that is statistically accurate, ensuring that your data is as close to real-world data as possible.',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: '#06090a',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4">
            Use Cases
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
          Cynthia can generate large amounts of synthetic data that resemble real-world data, enabling data engineers to work with data that doesn't compromise user privacy.
          </Typography>
        </Box>
        <Grid container spacing={2.5}>
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Stack
                direction="column"
                color="inherit"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  p: 3,
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'grey.800',
                  background: 'transparent',
                  backgroundColor: 'grey.900',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography fontWeight="medium" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
